<template>
  <el-form-item :label="$t('분류')">
    <el-radio-group v-model="localVal.dateSearchTp">
      <!--						<el-radio-button :label="$t('시간별')"></el-radio-button>-->
      <el-radio-button :label="$t('일별')"></el-radio-button>
      <el-radio-button :label="$t('월별')"></el-radio-button>
      <el-radio-button :label="$t('년별')"></el-radio-button>
    </el-radio-group>

    <div class="area-date">
      <template v-if="'HOUR' == localVal.dateSearchTpVal">
        <el-date-picker
          v-model="localVal.seDt"
          type="datetimerange"
          unlink-panels
          :style="{ width: $device.mobile ? `100%` : `360px` }"
          :clearable="false"
          :editable="false"
          value-format="yyyy-MM-dd HH:mm"></el-date-picker>
      </template>

      <template v-if="'DAY' == localVal.dateSearchTpVal">
        <el-date-picker
          v-model="localVal.seDt"
          type="daterange"
          unlink-panels
          :style="{ width: $device.mobile ? `100%` : `260px` }"
          :clearable="false"
          :editable="false"
          value-format="yyyy-MM-dd"></el-date-picker>
      </template>

      <template v-if="'MONTH' == localVal.dateSearchTpVal">
        <el-date-picker
          v-model="localVal.seDt"
          type="monthrange"
          unlink-panels
          :style="{ width: $device.mobile ? `100%` : `200px` }"
          :clearable="false"
          :editable="false"
          value-format="yyyy-MM"></el-date-picker>
      </template>

      <template v-if="'YEAR' == localVal.dateSearchTpVal">
        <el-date-picker
          v-model="localVal.startDt"
          type="year"
          :style="{ width: $device.mobile ? `calc(50% - 10px)` : `110px` }"
          :clearable="false"
          :editable="false"
          value-format="yyyy"></el-date-picker>
        ~
        <el-date-picker
          v-model="localVal.endDt"
          type="year"
          :style="{ width: $device.mobile ? `calc(50% - 10px)` : `110px` }"
          :clearable="false"
          :editable="false"
          value-format="yyyy"></el-date-picker>
      </template>
    </div>
  </el-form-item>
</template>

<script>
export default {
  props: ['value'],

  data() {
    return {
      localVal: this.value,
    }
  },
  watch: {
    value: {
      handler: function (newVal) {
        this.localVal = newVal
      },
      deep: true,
    },
    localVal: {
      handler: function (newVal) {
        this.$emit('update', newVal)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.area-date {
  display: inline-block;
  margin-left: 10px;
}

@media (max-width: 768px) {
  .area-date {
    display: block;
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>
